import PropTypes from 'prop-types';
import { values, keys, isNil } from 'ramda';

import { formatDate } from 'utils/date';
import { formatCurrency } from 'utils/numbers';

export const escrowAccountHeaders = [
  { entryDate: 'Date' },
  { cashReceipt: 'Cash Receipt From Securities' },
  { loanPayment: 'Payment On The Defeased Loan' },
  { cashBalance: 'Cash Balance' },
];
escrowAccountHeaders.getNames = () => escrowAccountHeaders.map(item => values(item)[0]);
escrowAccountHeaders.getDataKeys = () => escrowAccountHeaders.map(item => keys(item)[0]);

export const createTableRows = data => {
  if (isNil(data)) return null;
  return data.map(escrowAccount => ({
    id: escrowAccount.id,
    data: {
      entryDate: formatDate(escrowAccount?.entryDate),
      cashReceipt: formatCurrency(escrowAccount?.cashReceipt),
      loanPayment: formatCurrency(escrowAccount?.loanPayment),
      cashBalance: formatCurrency(escrowAccount?.cashBalance),
    },
  }));
};

export const loanEscrowAccountPropTypes = PropTypes.shape({
  entryDate: PropTypes.string,
  cashReceipt: PropTypes.string,
  loanPayment: PropTypes.string,
  cashBalance: PropTypes.string,
  id: PropTypes.number,
});
